module.exports = __webpack_public_path__ + "static/img/5.f33fec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/5.png
// module id = pbz3
// module chunks = 215